module.exports = __webpack_public_path__ + "static/media/redwood.4bcfa5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redwood.jpg
// module id = 104
// module chunks = 0